module.exports = __webpack_public_path__ + "static/Peyman-c74adc5b1c0ce473eeac869af2d0a7df.png";